import { render } from "./FooterRow.vue?vue&type=template&id=6c78110d&scoped=true"
import script from "./FooterRow.vue?vue&type=script&lang=js"
export * from "./FooterRow.vue?vue&type=script&lang=js"

import "./FooterRow.vue?vue&type=style&index=0&id=6c78110d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c78110d"]])

export default __exports__